import React, { useState, useEffect } from "react";
import ImageUploader from "./ImageUpload";
import MapDetailsBooking from "./MapDetailsBooking";
import StaticTables from "./BookingTables";
import axios from "axios";
import Compressor from "compressorjs";
import useMediaQuery from "@mui/material/useMediaQuery"; // For responsive design
import { Tabs, Tab } from "@mui/material"; // Import Tabs and Tab from Material UI
import BookingForm from "./BookingForm"; // Import the new BookingForm component

const MapsManagerBooking = ({ eventId, clubs }) => {
  //console.log("G first here are the parameters ", eventId, clubs);
  const [maps, setMaps] = useState([]);
  const [mapNames, setMapNames] = useState({});
  const [submittedNames, setSubmittedNames] = useState({});
  const [tableData, setTableData] = useState({});
  const [imageDimensions, setImageDimensions] = useState({});
  const [isLoaded, setIsLoaded] = useState(false); // To track if architecture is loaded
  const [isNewArchitecture, setIsNewArchitecture] = useState(true); // To track if we are creating a new architecture
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const adminId = localStorage.getItem("adminId");
  const [LoadingTablesChanges, setLoadingTablesChanges] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [categoriesPerMap, setCategoriesPerMap] = useState({});
  const [tableDataPerCategory, setTableDataPerCategory] = useState({});
  const [formVisible, setFormVisible] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [bookedMaps, setBookedMaps] = useState([]);
  useEffect(() => {
    fetchBookings();
  }, [eventId]);
  const handleTableClick = (table) => {
    setSelectedTable(table);
    setFormVisible(true);
  };
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  let clubId;
  if (clubs) {
    clubId = clubs;
  } else {
    clubId = JSON.parse(localStorage.getItem("clubIds"))[0];
  }
  const [notificationMessage, setNotificationMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Track loading state
  const [error, setError] = useState(null);

  // Fetch the saved architecture on component mount
  useEffect(() => {
    const loadSavedArchitecture = async () => {
      setIsLoading(true);
      try {
        let token = localStorage.getItem("token");
        const response = await axios.get(
          `${BACKEND_URL}/tables/event-tables/${eventId}/${clubId}`,
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );

        const maps = response?.data?.eventTables?.maps;
        console.log(
          "response.data:for the clubid ",
          clubId,
          eventId,
          "\n\n\n",
          response?.data?.eventTables?.maps
        );
        console.log("maps && maps.length > 0", maps && maps.length > 0);
        if (maps && maps.length > 0) {
          const newMaps = maps.map((map) => ({
            mapName: map.mapName,
            dataUrl: map.imageUrl, // Assuming imageUrl has been saved to Azure
            tables: map.tables
          }));
          setMaps(newMaps);

          const newMapNames = {};
          const newSubmittedNames = {};
          const newImageDimensions = {};
          const newTableData = {};
          const newCategoriesPerMap = {};
          const newTableDataPerCategory = {};

          // Load each image independently and set its corresponding table data once loaded
          newMaps.forEach((map, index) => {
            const img = new Image();
            img.src = map.dataUrl;

            img.onload = () => {
              newImageDimensions[index] = {
                width: img.width,
                height: img.height
              };

              // Set table data based on percentage values after image dimensions are known
              newTableData[index] = map.tables.map((table) => ({
                id: table.tableNumber,
                name: table.tableName,
                people: table.seats,
                price: table.price,
                pricesPerDay: table?.pricesPerDay,
                daysOfWeek: table.daysOfWeek,
                color: table.color,
                xPercentage: (table.x / img.width) * 100,
                yPercentage: (table.y / img.height) * 100,
                widthPercentage: (table.width / img.width) * 100,
                heightPercentage: (table.height / img.height) * 100,
                bookingDetails: table.bookingDetails,
                isAvailable: table.isAvailable,
                bookingFee: table.bookingFee,
                tableName: table.tableName // Ensure tableName is included
              }));
              const availableTables = newTableData[index].filter(
                (table) => table.isAvailable
              );
              const categories = [
                ...new Set(availableTables.map((table) => table.name))
              ];
              console.log("newCategoriesPerMap: ", newTableDataPerCategory);

              // Initialize newTableDataPerCategory[index] if it's undefined
              if (!newTableDataPerCategory[index]) {
                newTableDataPerCategory[index] = {};
              }

              newCategoriesPerMap[index] = categories;

              categories.forEach((name) => {
                newTableDataPerCategory[index][name] = availableTables.filter(
                  (table) => table.name === name
                );
              });

              // Update image dimensions, table data, and map names as they are ready
              setImageDimensions((prevDimensions) => ({
                ...prevDimensions,
                [index]: newImageDimensions[index]
              }));

              setTableData((prevTableData) => ({
                ...prevTableData,
                [index]: newTableData[index]
              }));

              newMapNames[index] = map.mapName;
              newSubmittedNames[index] = map.mapName;
              setMapNames((prevNames) => ({
                ...prevNames,
                ...newMapNames
              }));

              setSubmittedNames((prevSubmittedNames) => ({
                ...prevSubmittedNames,
                ...newSubmittedNames
              }));
              setCategoriesPerMap(newCategoriesPerMap);
              setTableDataPerCategory(newTableDataPerCategory);
            };
          });

          setIsNewArchitecture(false);
        } else {
          console.log("NO MASP FOUND ");
          setError(
            "Table Layout hasn't been uploaded by the venue. Will be available when the venue will upload it."
          );
        }
      } catch (error) {
        console.log(
          "No existing architecture found, allowing creation of new one.",
          error
        );
        setError(
          "Table Layout hasn't been uploaded by the venue. Will be available when the venue will upload it."
        );
      } finally {
        setIsLoaded(true);
        setIsLoading(false);
      }
    };
    loadSavedArchitecture();
  }, [clubId, BACKEND_URL, eventId]);

  const fetchBookings = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${BACKEND_URL}/tables/bookings/${eventId}`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );

      // Process the data to include necessary fields
      console.log(" response first:  ", response.data);
      const fetchedMaps = response.data.maps.map((map) => ({
        mapName: map.mapName,
        tables: map.tables.map((table) => ({
          ...table,
          price: table.price || table.bookingDetails.price || 0,
          seats: table.seats || table.bookingDetails.numberOfPeople || 0,
          tableName: table.tableName || ""
        }))
      }));
      setBookedMaps(fetchedMaps);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    }
  };

  const deriveCategoryFromName = (tableName) => {
    // Example: If tableName is "VIP Table 1", extract "VIP"
    // Adjust this function according to your naming convention
    const nameParts = tableName.split(" ");
    return nameParts[0]; // Returns "VIP" from "VIP Table 1"
  };

  const base64ToBlob = (base64, mime) => {
    const byteString = atob(base64.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([uint8Array], { type: mime });
  };

  // Handles image upload and sets the maps state
  const handleImagesLoaded = (loadedImages) => {
    const compressedImages = [];

    loadedImages.forEach((map) => {
      const blob = base64ToBlob(map.dataUrl, "image/jpeg"); // Assuming it's a JPEG image
      new Compressor(blob, {
        quality: 0.1,
        success(result) {
          const reader = new FileReader();
          reader.readAsDataURL(result);
          reader.onloadend = () => {
            compressedImages.push({
              name: map.name,
              dataUrl: reader.result
            });
            if (compressedImages.length === loadedImages.length) {
              setMaps(compressedImages);
            }
          };
        },
        error(err) {
          console.error(err.message);
        }
      });
    });

    setMaps(loadedImages);

    // Set the dimensions for each image
    const dimensions = loadedImages.reduce((acc, map, index) => {
      const img = new Image();
      img.src = map.dataUrl;
      img.onload = () => {
        acc[index] = { width: img.width, height: img.height };
      };
      return acc;
    }, {});
    setImageDimensions(dimensions);
  };

  // Handle map name changes
  const handleMapNameChange = (index, name) => {
    setMapNames((prevNames) => ({
      ...prevNames,
      [index]: name
    }));
  };

  const handleNameSubmit = (index) => {
    setSubmittedNames((prevSubmitted) => ({
      ...prevSubmitted,
      [index]: mapNames[index]
    }));
  };

  const handleTableDataChange = (index, tables) => {
    setTableData((prevData) => ({
      ...prevData,
      [index]: tables
    }));

    const mapName = submittedNames[index];
    const imageSize = imageDimensions[index];

    const updatedTables = convertToAbsoluteValues(
      tables,
      imageSize.width,
      imageSize.height
    );

    const updatedMap = {
      mapName: mapName,
      mapNumber: index + 1,
      imageUrl: maps[index].dataUrl,
      tables: updatedTables
    };

    setLoadingTablesChanges(true); // Start loading before API call
    try {
      console.log("INNNNNNNNNNNN");
      let token = localStorage.getItem("token");
      axios
        .post(
          `${BACKEND_URL}/tables/event-tables/update/${eventId}`,
          {
            updatedMaps: [updatedMap],
            id: adminId
          },
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        )
        .then((response) => {
          setLoadingTablesChanges(false); // Stop loading after success
          setNotificationMessage("Tables updated successfully!"); // Set success message
          setTimeout(() => setNotificationMessage(""), 3000); // Clear message after 3 seconds
        })
        .catch((error) => {
          setLoadingTablesChanges(false); // Stop loading after failure

          // Log detailed error information
          if (error.response) {
            // Server responded with a status code that falls out of the range of 2xx
            console.error("API Error Response:", error.response);
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            setNotificationMessage(
              `Error updating tables: ${error.response.data.message || error.message}`
            );
          } else if (error.request) {
            // The request was made but no response was received
            console.error("API Error Request:", error.request);
            setNotificationMessage(
              "Error updating tables: No response received from the server."
            );
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error("Error Message:", error.message);
            setNotificationMessage(`Error updating tables: ${error.message}`);
          }

          setTimeout(() => setNotificationMessage(""), 3000); // Clear message after 3 seconds
        });
    } catch (error) {
      setLoadingTablesChanges(false); // Stop loading in case of error
      console.error("Unexpected Error in handleTableDataChange:", error);
    }
  };

  const convertToAbsoluteValues = (tables = [], imageWidth, imageHeight) => {
    if (!tables || tables.length === 0) {
      console.warn("Tables data is missing or empty.");
      return []; // Return an empty array to avoid further errors
    }

    return tables.map((table) => ({
      tableName: table.name,
      tableNumber: table.id,
      seats: parseInt(table.people),
      pricesPerDay:
        table.pricingType === "universal"
          ? Array(7).fill(parseFloat(table.price))
          : table?.pricesPerDay?.map((price) => parseFloat(price) || 0) || [], // Handle undefined pricesPerDay
      daysOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      x: (table.xPercentage / 100) * imageWidth,
      y: (table.yPercentage / 100) * imageHeight,
      width: (table.widthPercentage / 100) * imageWidth,
      height: (table.heightPercentage / 100) * imageHeight,
      color: table.color,
      bookingDetails: table.bookingDetails,
      isAvailable: table.isAvailable,
      bookingFee: table.bookingFee
    }));
  };

  // Submit the architecture data to the backend

  useEffect(() => {
    if (submittedNames && tableData && imageDimensions) {
    }
    console.log("maps", submittedNames, tableData, imageDimensions);
  }, [maps, submittedNames, tableData, imageDimensions]);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "stretch" // Ensure both sections stretch to equal height
      }}
    >
      {/* Left Section: New Booking Possibility */}
      <div
        style={{
          display: "flex", // Enables flexbox layout
          flexDirection: "column", // Aligns items vertically
          flex: 1,
          padding: "20px", // Adds padding around the form
          backgroundColor: "#F0F0F0", // Light gray background
          marginTop: "20px", // Adds top margin to create space
          borderRadius: "15px" // Rounds the corners
          //marginLeft: "auto", // Centers the div horizontally
          //marginRight: "auto" // Centers the div horizontally
        }}
      >
        <h3>Table Bookings</h3>

        <BookingForm
          tableCategories={categoriesPerMap[selectedTab]}
          tableDataPerCategory={tableDataPerCategory}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          handleTabChange={handleTabChange}
          maps={maps}
          formVisible={formVisible}
          setFormVisible={setFormVisible}
          selectedTable={selectedTable}
          setSelectedTable={setSelectedTable}
          eventId={eventId}
          bookedMaps={bookedMaps}
          fetchBookings={fetchBookings}
        />
      </div>
      {/* Right Section: Maps in Tabs */}
      {!isMobile && (
        <div
          style={{
            flex: 1.3,
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between" // Ensure equal space distribution
          }}
        >
          {" "}
          {/* Increased flex value */}
          <h3>
            {isNewArchitecture
              ? "Upload your table maps"
              : "View your table maps"}
          </h3>
          {isLoading && <div>Loading...</div>}
          {error && <div style={{ color: "red" }}>{error}</div>}
          {notificationMessage && (
            <div
              style={{
                backgroundColor: notificationMessage.includes("Error")
                  ? "#f8d7da"
                  : "#d4edda",
                color: notificationMessage.includes("Error")
                  ? "#721c24"
                  : "#155724",
                padding: "10px",
                borderRadius: "5px",
                marginTop: "20px",
                textAlign: "center"
              }}
            >
              {notificationMessage}
            </div>
          )}
          {isLoaded &&
            !error &&
            !isLoading &&
            tableData &&
            mapNames &&
            maps && (
              <>
                {isNewArchitecture && (
                  <ImageUploader onImagesLoaded={handleImagesLoaded} />
                )}

                {/* Tabs for Maps */}
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {maps.map((map, index) => (
                    <Tab
                      key={index}
                      label={submittedNames[index] || `Map ${index + 1}`}
                    />
                  ))}
                </Tabs>

                {maps.map((map, index) => {
                  if (index !== selectedTab) return null; // Only render the selected tab
                  return (
                    <div key={index} style={{ marginTop: "20px", flexGrow: 1 }}>
                      {submittedNames[index] && imageDimensions[index] && (
                        <StaticTables
                          imageUrl={map.dataUrl}
                          mapName={submittedNames[index]}
                          initialTables={tableData[index]}
                          onTableDataChange={(tables) =>
                            handleTableDataChange(index, tables)
                          }
                          eventId={eventId}
                          selectedTab={selectedTab}
                          ind={index}
                          style={{ height: "100%" }} // Ensure StaticTables stretches fully
                          handleTableClick={handleTableClick}
                        />
                      )}
                    </div>
                  );
                })}
              </>
            )}
        </div>
      )}
    </div>
  );
};

export default MapsManagerBooking;
